import { render } from "./DiffView.vue?vue&type=template&id=32f444a6"
import script from "./DiffView.vue?vue&type=script&lang=js"
export * from "./DiffView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__